require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _color = _interopRequireDefault(require("color"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _TouchableRipple = _interopRequireDefault(require("../TouchableRipple"));

var _Text = _interopRequireDefault(require("../Typography/Text"));

var _theming = require("../../core/theming");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/List/ListItem.tsx";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var ListItem = function (_React$Component) {
  (0, _inherits2["default"])(ListItem, _React$Component);

  function ListItem() {
    (0, _classCallCheck2["default"])(this, ListItem);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ListItem).apply(this, arguments));
  }

  (0, _createClass2["default"])(ListItem, [{
    key: "renderDescription",
    value: function renderDescription(descriptionColor, description) {
      var _this$props = this.props,
          descriptionEllipsizeMode = _this$props.descriptionEllipsizeMode,
          descriptionStyle = _this$props.descriptionStyle,
          descriptionNumberOfLines = _this$props.descriptionNumberOfLines;
      return typeof description === 'function' ? description({
        ellipsizeMode: descriptionEllipsizeMode,
        color: descriptionColor,
        fontSize: styles.description.fontSize
      }) : React.createElement(_Text["default"], {
        numberOfLines: descriptionNumberOfLines,
        ellipsizeMode: descriptionEllipsizeMode,
        style: [styles.description, {
          color: descriptionColor
        }, descriptionStyle],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 144
        }
      }, description);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          left = _this$props2.left,
          right = _this$props2.right,
          title = _this$props2.title,
          description = _this$props2.description,
          onPress = _this$props2.onPress,
          theme = _this$props2.theme,
          style = _this$props2.style,
          titleStyle = _this$props2.titleStyle,
          titleNumberOfLines = _this$props2.titleNumberOfLines,
          titleEllipsizeMode = _this$props2.titleEllipsizeMode,
          rest = (0, _objectWithoutProperties2["default"])(_this$props2, ["left", "right", "title", "description", "onPress", "theme", "style", "titleStyle", "titleNumberOfLines", "titleEllipsizeMode"]);
      var titleColor = (0, _color["default"])(theme.colors.text).alpha(0.87).rgb().string();
      var descriptionColor = (0, _color["default"])(theme.colors.text).alpha(0.54).rgb().string();
      return React.createElement(_TouchableRipple["default"], (0, _extends2["default"])({}, rest, {
        style: [styles.container, style],
        onPress: onPress,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 182
        }
      }), React.createElement(_reactNative.View, {
        style: styles.row,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 187
        }
      }, left ? left({
        color: descriptionColor,
        style: description ? styles.iconMarginLeft : _objectSpread({}, styles.iconMarginLeft, {}, styles.marginVerticalNone)
      }) : null, React.createElement(_reactNative.View, {
        style: [styles.item, styles.content],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 199
        }
      }, React.createElement(_Text["default"], {
        ellipsizeMode: titleEllipsizeMode,
        numberOfLines: titleNumberOfLines,
        style: [styles.title, {
          color: titleColor
        }, titleStyle],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 200
        }
      }, title), description ? this.renderDescription(descriptionColor, description) : null), right ? right({
        color: descriptionColor,
        style: description ? styles.iconMarginRight : _objectSpread({}, styles.iconMarginRight, {}, styles.marginVerticalNone)
      }) : null));
    }
  }]);
  return ListItem;
}(React.Component);

(0, _defineProperty2["default"])(ListItem, "displayName", 'List.Item');
(0, _defineProperty2["default"])(ListItem, "defaultProps", {
  titleNumberOfLines: 1,
  descriptionNumberOfLines: 2
});

var styles = _reactNative.StyleSheet.create({
  container: {
    padding: 8
  },
  row: {
    flexDirection: 'row'
  },
  title: {
    fontSize: 16
  },
  description: {
    fontSize: 14
  },
  marginVerticalNone: {
    marginVertical: 0
  },
  iconMarginLeft: {
    marginLeft: 0,
    marginRight: 16
  },
  iconMarginRight: {
    marginRight: 0
  },
  item: {
    marginVertical: 6,
    paddingLeft: 8
  },
  content: {
    flex: 1,
    justifyContent: 'center'
  }
});

var _default = (0, _theming.withTheme)(ListItem);

exports["default"] = _default;